// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 763) return "static/chunks/763-61ee83d132acc8a1.js";
	if (chunkId === 4480) return "static/chunks/4480-d4f230b4e7e29e91.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4070 ? "b2f0368f" : chunkId) + "." + {"4070":"f2ab974e4b2686f0","4198":"489f2cc5633d45ff","4496":"8f9c115b1f1871b1"}[chunkId] + ".js";
};